import { Button, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/styles";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router";
import axiosInstance from "src/utils/axios";
import "../mainPage/assets/css/style.css";
import "./css/bootstrap.min.css";
import "./css/style.css";
import sbLogo from "../mainPage/images/samualLogo.png";
import footersbLogo from "../mainPage/images/samualfooterLogo.png";
import banner from "../mainPage/images/banner.png";
import DoubleQuotes from "../mainPage/images/double-quotes.png";
import Bgsamual from "../mainPage/images/sambusinessBg.webp";
import TrainingCryptocurrencies from "../mainPage/images/TrainingCryptocurrencies.png";
import CryptocurrencySignals from "../mainPage/images/CryptocurrencySignals.png";
import AutomaticTrading from "../mainPage/images/AutomaticTrading.png";
import Staking from "../mainPage/images/Staking.png";
import Stocks from "../mainPage/images/Stocks.png";
import FractionalRealEstate from "../mainPage/images/FractionalRealEstate.png";
import NetworkMarketing from "../mainPage/images/NetworkMarketing.png";
import sam from "../mainPage/images/sam.png";
import network from "../mainPage/images/network.png";
import useAuth from "src/hooks/useAuth";
import LanguagePopover from "src/layouts/shared/header/language-popover";
import { useTranslation } from "react-i18next";
import uk from "src/images/united-kingdom.png";
import french from "src/images/france.png";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { PATH_AUTH, PATH_USER } from "src/routes/paths";
import Crtpto from "./cryptoValues";
import useCategories from "src/hooks/useCategories";
import Map from "src/components/map";

const MainPage = () => {
  const { uname } = useParams();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [openRegister, setOpenRegister] = useState(false);
  const [openLogin, setOpenLogin] = useState(false);
  const [emailMessage, setEmailMessage] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { user, logout, isAdmin } = useAuth();
  const lang = localStorage.getItem("i18nextLng");

  const isLoggedIn = !user;
  const { t } = useTranslation();

  const { state } = useCategories();
  const { data } = state;
  console.log(data);
  const handleClickOpenRegister = () => {
    setOpenRegister(true);
    setOpenLogin(false);
  };

  const handleCloseRegister = () => {
    setOpenRegister(false);
  };

  const handleClickOpenLogin = () => {
    setOpenLogin(true);
    setOpenRegister(false);
  };

  const handleCloseLogin = () => {
    setOpenLogin(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    if (uname) {
      handleClickOpenRegister();
    }
  }, [uname]);

  const fetchBrandSettings = async () => {
    try {
      const { data, status } = await axiosInstance("api/brand-details");
      if (status === 200) {
        const { logo, side_bar_logo, favicon } = data.data;
        if (logo) {
          localStorage.setItem("logo", logo);
          localStorage.setItem("side_bar_logo", side_bar_logo);
          localStorage.setItem("favicon", favicon);
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchBrandSettings();
  }, []);
  return (
    <>
      <Helmet>
        <meta charset="utf-8" />
        <meta http-equiv="X-UA-Compatible" content="IE=edge" />
        <meta name="keywords" content="" />
        <meta name="author" content="" />
        <meta name="robots" content="" />
        <meta name="description" content="" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <link rel="stylesheet" href="assets/css/bootstrap.min.css" />
        <link rel="stylesheet" href="assets/css/style.css" />
        <script src="js/jquery-1.12.4.min.js"></script>
        <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/js/bootstrap.bundle.min.js"></script>
        <link
          href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;1,100;1,200;1,300;1,400&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://cdn.jsdelivr.net/npm/remixicon@4.2.0/fonts/remixicon.min.css"
          rel="stylesheet"
        />
      </Helmet>
      <body>
        <div className="bodyBox">
          <div className="container" id="navbar">
            <header className="page-header">
              <div className="page-header__top">
                <div className="page-header__toggle" onClick={toggleMenu}>
                  ☰
                </div>
              </div>
              <nav className="page-header__bottom">
                <ul
                  id="navigation"
                  className={`navigation ${
                    isMenuOpen ? "navigation--visible" : ""
                  }`}
                >
                  <li className="navigation__item">
                    <a href="#">{t("global.home")}</a>
                  </li>
                  <li className="navigation__item">
                    <a href="#about">{t("global.about")}</a>
                  </li>
                  <li className="navigation__item">
                    <a href="/faq">FAQ</a>
                  </li>
                </ul>
              </nav>
              <div className="page-header__logo">
                <img src={sbLogo} alt="Sambusiness Logo" />
              </div>
              <ul className="loginBox">
                <LanguagePopover />
                <li className="navigation__item">
                  {isLoggedIn ? (
                    <>
                      <a
                        className="loginButton"
                        href={
                          isAdmin
                            ? "/admin/dashboard/business"
                            : "/user/dashboard"
                        }
                      >
                        {t("global.logIn")}
                      </a>
                      <a className="registerButton" href="/auth/register">
                        {t("global.register")}
                      </a>
                    </>
                  ) : (
                    <>
                      <a className="loginButton" href="/auth/login">
                        {t("global.Dashboard")}
                      </a>
                    </>
                  )}
                </li>
              </ul>
            </header>
          </div>
          <div className="bannerBox">
            <div className="container">
              <div className="row align-items-center mdflex-column-reverse">
                <div className="col-md-5">
                  <img src={banner} alt="Sambusiness community" />
                  <div className="d-flex justify-center mt-3">
                    {/* <a className="commonButton mt-25" href="/auth/register">
                      {t("global.getNow")}
                    </a> */}
                  </div>
                </div>
                <div className="col-md-1"></div>
                <div className="col-md-6">
                  <img
                    src={DoubleQuotes}
                    alt="Sambusiness community"
                    className="DoubleQuotes"
                  />
                  <p className="bannerpara">{t("global.futreText")}</p>
                  <h1 className="bannerTitle titleFont">
                    <span>{t("global.the")}</span> {t("global.futre")}
                  </h1>
                  <span className="bannerTitle titleFont">
                    {" "}
                    {t("global.futre2")}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <main>
            <Crtpto />

            <section
              className="sectionpadding"
              style={{
                backgroundImage: `url(${Bgsamual})`,
                backgroundAttachment: "fixed",
              }}
            >
              <div id="about" className="container">
                <div className="text-center samualSection">
                  <h2 className="mainTitlesamual text-uppercase">
                    {t("global.SambusinessCommunity")}
                  </h2>
                  <p className="paraColor text-center d-block text-white SambusinessComunityText">
                    {t("global.SambusinessCommunityText")}
                  </p>
                </div>
              </div>
            </section>
            <section className="sectionpadding">
              <div className="container">
                <div className="col-xl-9 mx-auto">
                  <h3 className="Title">CATEGORIES</h3>
                  <div className="row mt-5">
                    <Map
                      list={data}
                      render={(item) => (
                        <div className="col-md-6">
                          <div className="categoryBg">
                            <div className="categoryImage">
                              <img
                                src={item?.product_images?.[0]?.image_url}
                                alt="Sambusiness community"
                              />
                            </div>
                            <div className="categorySubBox">
                              <div className="categoryCount">
                                0{item?.subscriptions_id}.
                              </div>
                              <div className="categoryTitle">
                                {lang === "fr" ? item?.name_fr : item?.name}
                              </div>

                              <div
                                style={{
                                  marginTop: 16,
                                  display: "flex",
                                  gap: 8,
                                }}
                              >
                                <Button
                                  component={RouterLink}
                                  to={
                                    !isLoggedIn
                                      ? PATH_USER.subscriptionDoc.categories.view(
                                          item.subscriptions_id
                                        )
                                      : PATH_AUTH.login
                                  }
                                  variant="contained"
                                  color="primary"
                                  sx={{ fontStyle: "italic" }}
                                >
                                  French
                                </Button>

                                <Button
                                  component={RouterLink}
                                  to={
                                    !isLoggedIn
                                      ? PATH_USER.subscriptionEng.categories.view(
                                          item.subscriptions_id
                                        )
                                      : PATH_AUTH.login
                                  }
                                  state={{ moduleName: item.name }}
                                  variant="contained"
                                  color="primary"
                                  sx={{ fontStyle: "italic" }}
                                >
                                  English
                                </Button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    />
                  </div>
                </div>
              </div>
            </section>

            <section className="bgceo">
              <div className="container">
                <div className="col-xl-10 mx-auto">
                  <div className="row">
                    <div className="col-md-5">
                      <img
                        className="smaImg"
                        src={sam}
                        alt="Sambusiness community"
                      />
                    </div>
                    <div className="col-md-7 text-center py-10">
                      <h4 className="samtitle text-white">
                        {t("global.Founder")}
                      </h4>
                      <h4 className="samtitle2 text-white">
                        {t("global.ceoSambusiness")}
                      </h4>
                      <p className="paraColor text-white">
                        {t("global.dedicated")}
                      </p>
                      <p className="paraColor text-white">
                        <b>{t("global.Sawadogo")}</b>,{" "}
                        {t("global.Sawadogoinvestment")}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section className="sectionpadding">
              <div className="container">
                <div className="text-center">
                  <div className="col-md-7 mx-auto">
                    <h4 className="Title text-uppercase">
                      {t("global.Exciting")}
                    </h4>
                    <div className="col-md-12 d-flex justify-content-end">
                      <img src={network} alt="Sambusiness community" />
                    </div>
                  </div>
                  <div className="col-md-9 mx-auto">
                    <p className="paraColor mt-3 pb_30">
                      {t("global.successshould")}
                    </p>

                    <div className="d-flex flex-wrap align-items-center justify-center mt-3">
                      <h5 className="planTitle">{t("global.Plans")}</h5>
                      <a
                        className="appLink"
                        href="/files/french.pdf"
                        target="_blank"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          textDecoration: "none",
                        }}
                      >
                        <img
                          style={{ width: "30px" }}
                          src={french}
                          alt="Sambusiness community"
                        />
                        <span>French</span>
                      </a>

                      <a
                        className="appLink"
                        href="/files/english.pdf"
                        target="_blank"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          textDecoration: "none",
                        }}
                      >
                        <img
                          style={{ width: "30px" }}
                          src={uk}
                          alt="Sambusiness community"
                        />
                        <span>English</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section className="sectionpadding pt-0">
              <div className="container">
                <div className="joinBox">
                  <div className="col-md-9 text-center mx-auto">
                    <h5 className="joinTitle text-uppercase text-white">
                      {t("global.todayexclusive")}
                    </h5>
                    <p className="text-white">{t("global.journey")}</p>
                  </div>
                  <div className="col-md-9 text-center mx-auto">
                    <div className="d-flex justify-center mt-3">
                      <a className="joinButton" href="auth/register">
                        {t("global.NowJoin")}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </main>

          <footer className="footerSection">
            <div className="container">
              <img
                style={{ width: "80px", margin: "auto" }}
                src={footersbLogo}
                alt="Sambusiness Footer Logo"
              />
              <p className="text-white mt-4">
                support@sbcommunity.net <br />
                Cocody Angré, Abidjan, Côte d'Ivoire
              </p>
              <ul className="footerNav text-white">
                <li>
                  <a href="/terms">{t("global.Policy")}</a>
                </li>
                <li>
                  <a href="/terms">{t("global.ServiceTerms")}</a>
                </li>
              </ul>
              <p className="mt-5 text-white font-13">{t("global.copuRight")}</p>
            </div>
          </footer>
        </div>
      </body>
    </>
  );
};

export default MainPage;
